import React from 'react';
import { useSelector } from 'react-redux';

import OrderNumberLink from '../../../../../components/order-number-link';
import Global from '../../../../../store/global-selectors';

export const OrderNumberReturnsGridColumn = ({ id = '', orderNumber = '', salesOrderId = '' }) => {
  const salesOrder = useSelector((state) => {
    if (!salesOrderId) {
      return null;
    }
    return Global.selectEntitiesSalesOrderById(state, { salesOrderId });
  });

  if (!salesOrder) {
    return orderNumber || '';
  }

  return <OrderNumberLink id={id} orderNumber={orderNumber} salesOrderId={salesOrderId} selectGridWhenClicked />;
};
